<button type="button" class="filter-tag" [class.warning]="!record.rule.operator">
  <div class="d-flex align-items-center spacing-8">
    <app-ce-icon
      name="{{ record.entry.icon }}"
      [svg_class]="['d-flex', 'primary-50']"></app-ce-icon>
    <div class="d-flex align-items-center spacing-4">
      <span class="h3-reg primary-60">{{ record.entry.label }} :</span>
      <app-filter-operator-label
        [rule]="record.rule"
        [operator]="record.rule.operator"></app-filter-operator-label>
      @if (record.rule.operator === Operator.LastX && requiresLastValueDisplay) {
        {{ formattedDisplayValue }}
      }
      @if (requiresValue && requiresValueDisplay) {
        <span class="h4-bold" *ngIf="record?.entry?.group !== 'events'">
          {{ formattedDisplayValue }}</span
        >
      }
    </div>
  </div>
  <span
    *ngIf="!readonly"
    class="close-btn"
    (click)="onRecordRemove()"
    (keydown.enter)="onRecordRemove()"
    tabindex="0"
    role="button"
    aria-label="Remove filter">
    <img
      data-bs-dismiss="alert"
      aria-hidden="true"
      aria-label="Close"
      alt=""
      src="/assets/cancel.svg" />
  </span>
</button>
